import React from "react";
import styled from "styled-components";
import SearchIcon from "@material-ui/icons/Search";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { colors, zIndex } from "@sonder/ui/source/styled/theme";
import { useStore as useAuthStore } from "auth/store";
import { SearchModal } from "search/components/SearchModal";

const StyledCircleButton = styled(CircleButton)`
  background-color: ${colors.white};
  border-radius: 1.437rem;
  box-shadow: 0px 0.286rem 1.429rem rgba(0, 0, 0, 0.08);
  height: 2.857rem;
  width: 2.857rem;

  &:hover {
    background-color: ${colors.grayE};
    cursor: pointer;
  }
`;

const Wrapper = styled.div`
  bottom: 1.714rem;
  left: 5.571rem;
  position: fixed;
  z-index: ${zIndex.floatingSearchButton};
`;

export const FloatingSearchButton: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const {
    state: { user },
  } = useAuthStore();

  const cityId = user?.cityId;

  if (!cityId) return null;

  return (
    <Wrapper>
      <StyledCircleButton
        backgroundVariant="light"
        data-testid="search-button"
        onClick={openModal}
      >
        <SearchIcon />
      </StyledCircleButton>

      {isOpen && (
        <SearchModal cityId={cityId} closeModal={closeModal} isOpen={isOpen} />
      )}
    </Wrapper>
  );
};
